import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/galleryShadow.svg';

export const IconGalleryShadow = createIconComponent(Icon);
